export default "__VITE_ASSET__Duq5BgSq__"